// Cross-subdomain "has a session" hint for the marketing site.
//
// The landing page (vivideo.ai) auto-forwards returning users to the app, but the
// Firebase session lives in origin-scoped IndexedDB on app.vivideo.ai — invisible to
// the landing. This cookie is the bridge: a plain boolean flag on the parent domain
// (.vivideo.ai) that both subdomains can read. It carries NO identity and NO token —
// the app still authenticates purely from its own Firebase/localStorage state, so a
// forged or stale cookie only ever costs a visitor one hop to the app's login screen.

const COOKIE_NAME = 'vv_auth';
// Refreshed on every app load by AuthContext, so active users never expire.
const MAX_AGE_SECONDS = 180 * 24 * 60 * 60;

// On *.vivideo.ai the cookie must sit on the parent domain so vivideo.ai can read it.
// On any other host (localhost dev, vivideo-ai.web.app) the browser would reject a
// .vivideo.ai domain attribute, so fall back to a host-only cookie — localhost is
// still useful for testing, since the landing dev server shares it (cookies ignore
// ports).
function domainAttribute(): string {
  const host = window.location.hostname;
  return host === 'vivideo.ai' || host.endsWith('.vivideo.ai') ? '; domain=.vivideo.ai' : '';
}

function secureAttribute(): string {
  return window.location.protocol === 'https:' ? '; secure' : '';
}

export function setAuthHintCookie(): void {
  try {
    document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${MAX_AGE_SECONDS}${domainAttribute()}; samesite=lax${secureAttribute()}`;
  } catch {
    // Cookies blocked — the landing simply won't auto-redirect this browser.
  }
}

export function clearAuthHintCookie(): void {
  try {
    document.cookie = `${COOKIE_NAME}=; path=/; max-age=0${domainAttribute()}; samesite=lax${secureAttribute()}`;
  } catch {
    // noop
  }
}
